var _rect, _g, _rect2, _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssignUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-size",
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "#F7F8F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8393_36501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5004 17.0006C20.0646 17.0006 22.1433 14.9219 22.1433 12.3577C22.1433 9.79352 20.0646 7.71484 17.5004 7.71484C14.9363 7.71484 12.8576 9.79352 12.8576 12.3577C12.8576 14.9219 14.9363 17.0006 17.5004 17.0006Z",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.329 26.2863C25.7293 24.4161 24.5511 22.7847 22.9644 21.6272C21.3777 20.4697 19.4645 19.846 17.5004 19.846C15.5364 19.846 13.6232 20.4697 12.0365 21.6272C10.4498 22.7847 9.27162 24.4161 8.67188 26.2863H26.329Z",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    stroke: "#64748B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 29,
    r: 7,
    fill: "#64748B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4996 24.7148V33.2863M25.2139 29.0006H33.7853",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8393_36501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(7.5 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignUser);
export default __webpack_public_path__ + "static/media/AssignUser.10192bde57dedfcd521d71846de71d8b.svg";
export { ForwardRef as ReactComponent };